const GroupInvoiceTemplate = `
<style>
            .Invoice{
                font-family: "timesnewroman";
                line-height: 1.2;
            }
            .main-header{
                display: flex;
                justify-content: space-between;
                margin-bottom: 1rem;
                align-items: center;
            }
            .api-icp-logo{
                height: 2.75rem;
                width: 22rem;
            }
            .secondary-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px solid black;
            }

            .group-invoice-id, .invoice-title {
                font-weight: bold;
                white-space: nowrap;
            }
            .date p {
            margin: 0;
            }
            .Invoice-date-title{
                text-align: right;
                font-weight: bold;
            }
            p{
                margin: 0;
                padding: 0;
            }
            .address-section{
                display: flex;
                justify-content: space-between;
            }
            .billing-address, .mailing-address{
                flex: 1;
            }
            .address-details{
                border: 1px solid black;
                margin-right: 1em;
            }
            .address-title{
                font-weight: bold;
                margin: 0.7em 0;
            }
            .address-data{
                padding-left: 0.5em;
            }
            .bold{
                font-weight: bold;
            }
            .invoice-description{
                margin-top: 1em;
            }
            .invoice-table {
                width: 100%;
                border-collapse: collapse;
            }
            th{
                font-size: 11px;
            }
            td{
                font-size: 13px;
            }
            .invoice-table th,
            .invoice-table td {
                padding-left: 0.5em;
                text-align: left;
                border-top: 1px solid #000;
                border-bottom: 1px solid #000;
                border-left: none;
                border-right: none;
            }

            /* Column widths */
            .qty {
                width: 10%;
            }

            .name {
                width: 20%;
            }

            .order {
                width: 10%;
            }

            .code {
                width: 40%;
            }

            .amount {
                width: 20%;
                text-align: right !important;
                padding-right: 6px !important;
            }
            .fs-23{
                font-size: 23px;
            }
            .fs-18{
                font-size: 18px;
            }
            .fs-15{
                font-size: 15px;
            }
            .fs-13{
                font-size: 13px;
            }
            .footer{
                display: flex;
                flex-direction: column;
            }
            .mainfooter{
                display: flex;
                justify-content: space-between;
            }
            .subfooter{
                display: flex;
                justify-content: space-between;
            }

            .invoice {
                display: flex;
                flex-direction: column;
            }

            .content {
                flex: 1;
                min-height:780px;
            }

            .footer {
                margin-top: auto;
            }
            .order-items{
                padding-top: 1rem;
            }
            .order-summary{
                display: flex;
                padding-top: 1rem;
            }
            .id-note{
                width: 45%;
            }
            .ordersummary-note{
                padding-top: 2.5rem;
                font-size: 15px;
                font-weight: bold;
            }
            .icp-seal{
                height: 14rem;
                padding-top: 1.5rem;
            }
            .order-breakdown{
                width: 40%;
                padding-left: 4px;
            }
            .wrap-text {
                white-space: normal;
                overflow-wrap: anywhere;
                word-break: break-word;
                }
            .header,
            .footer,
            .order-summary {
            break-inside: avoid;
            }
        </style>
        <div class="Invoice">
            <div class="content">
                <div class="header">
                    <div class="main-header">
                        <div class="logo">
                            {{logo}}
                        </div>
                        <div class="invoice-title">
                            <p class="fs-23">ICP Invoice</p>
                        </div>
                    </div>
                    <div class="secondary-header">
                        <div class="group-invoice-id">
                            <p class="fs-23">Invoice # {{invoiceNumber}}</p>
                        </div>
                        <div class="date">
                            <p class="Invoice-date-title fs-15">Invoice Date</p>
                            <p class="fs-15">{{date}}</p>
                        </div>
                    </div>
                </div>
                <div class="address-section">
                    <div class="billing-address">
                        <p class="address-title fs-13">Billing Address:</p>
                        <div class="address-details">
                            <div class="address-data">
                                <p class="fs-15">{{companyName}}</p>
                                <p class="fs-15">Attn: {{firstName}} {{lastName}}</p>
                                <p class="fs-15">{{addressline1}}</p>
                                <p class="fs-15">{{addressline2}}</p>
                                <p class="fs-15">{{city}}, {{province}} {{postalCode}}</p>
                                <p class="fs-15">{{country}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mailing-address">
                        <p class="address-title fs-13">Mailing Address:</p>
                        <div class="address-details">
                            <div class="address-data">
                                <p class="fs-15">Attn: {{mailingfirstName}} {{mailinglastName}}</p>
                                <p class="fs-15">{{mailingaddressline1}}</p>
                                <p class="fs-15">{{mailingaddressline2}}</p>
                                <p class="fs-15">{{mailingcity}}, {{mailingprovince}} {{mailingpostalCode}}</p>
                                <p class="fs-15">{{mailingcountry}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="invoice-description">
                    {{InvoiceDescription}}
                </div>
                <div class="order-items">
                    <table class="invoice-table">
                        {thead}
                        <thead>
                            <tr>
                            <th class="qty">Quantity</th>
                            <th class="name">Name</th>
                            <th class="order">Order #</th>
                            <th class="code">Product Code</th>
                            <th class="amount">Amount</th>
                            </tr>
                        </thead>
                        {/thead}
                        <tbody>
                        {{tableRows}}
                        </tbody>
                    </table>
                </div>
                {orderSummary}
                <div class="order-summary">
                    <div class="id-note">
                        <p class="fs-13">ICP ID {{icpId}}</p>
                        <p class="ordersummary-note">Please return a copy of this invoice with your
                            payment. Also follow the additional payment-submission details below.</p>
                    </div>
                    <div class="seal">
                        {{stamp}}
                    </div>
                    <div class="order-breakdown">
                        <table>
                            <tr>
                            <td class="bold">Subtotal</td>
                            <td class="amount">{{totalAmount}}</td>
                            </tr>
                        </table>

                        <hr />

                        <table>
                            <tr>
                            <td class="bold fs-18">TOTAL</td>
                            <td class="amount bold fs-18">{{totalAmount}}</td>
                            </tr>
                            <tr>
                            <td class="bold fs-18">Payment Received</td>
                            <td class="amount bold fs-18">$0.00</td>
                            </tr>
                        </table>

                        <hr />

                        <table>
                            <tr>
                            <td class="bold fs-18">Balance Due</td>
                            <td class="amount bold fs-18">{{totalAmount}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                {/orderSummary}
            </div>
            <div class="footer">
                <div class="mainfooter">
                    <div class="sendcheck">
                        {{CheckMailToAddress}}
                    </div>
                    <div class="sendwire">
                        {{WireTransferMailToAddress}}
                    </div>

                    <div class="sendcorrsos">
                        {{CorrespondenceToAddress}}
                    </div>
                </div>  
                <div class="subfooter">
                    <div class="taxid">
                        {{FederalTaxInstructions}}
                    </div>
                    <div class="email">
                        <p class="fs-15">{{email}}</p>
                    </div>
                </div>
            </div>
        </div>`;

export default GroupInvoiceTemplate;

export const InvoiceLayout = {
  MaxNameCharPerLine: 24,
  MaxProductNameCharPerLine: 34,
  MaxUnitsWithSummary: 13,
  MaxUnitsWithoutSummary: 22,
} as const;
